export default "__VITE_ASSET__785f49ab__"